import { ITargetThreshold } from '../threshold/target-threshold';
import { IThreshold } from '../threshold/threshold';

export interface IKpiQueueThreshold {
    slaThreshold?: number;
    maxLwtSeconds?: number;
    averageWaitTimeSeconds?: number;
    maxConversationsWaiting?: number;
}

export interface ITelXLKpiQueueThreshold {
    slaThreshold: IThreshold;
    maxLongestWaitTimeSeconds: IThreshold;
    averageWaitTimeSeconds: IThreshold;
    maxConversationsWaiting: IThreshold;
    averageHandlingTimeSeconds: ITargetThreshold;
}

export const TelXLKpiQueueThresholdDefaultState: ITelXLKpiQueueThreshold = {
    slaThreshold: {
        low: 0,
        high: 0,
        enabled: false,
    },
    averageWaitTimeSeconds: {
        low: 0,
        high: 0,
        enabled: false,
    },
    maxConversationsWaiting: {
        low: 0,
        high: 0,
        enabled: false,
    },
    maxLongestWaitTimeSeconds: {
        low: 0,
        high: 0,
        enabled: false,
    },
    averageHandlingTimeSeconds: {
        low: 0,
        high: 0,
        target: 0,
        enabled: false,
    },
};

export const mergeMissingQueueThresholds = (
    threshold: ITelXLKpiQueueThreshold,
) => {
    if (!threshold.slaThreshold) {
        threshold.slaThreshold =
            TelXLKpiQueueThresholdDefaultState.slaThreshold;
    }
    if (!threshold.maxLongestWaitTimeSeconds) {
        threshold.maxLongestWaitTimeSeconds =
            TelXLKpiQueueThresholdDefaultState.maxLongestWaitTimeSeconds;
    }
    if (!threshold.averageWaitTimeSeconds) {
        threshold.averageWaitTimeSeconds =
            TelXLKpiQueueThresholdDefaultState.averageWaitTimeSeconds;
    }
    if (!threshold.maxConversationsWaiting) {
        threshold.maxConversationsWaiting =
            TelXLKpiQueueThresholdDefaultState.maxConversationsWaiting;
    }
    if (!threshold.averageHandlingTimeSeconds) {
        threshold.averageHandlingTimeSeconds =
            TelXLKpiQueueThresholdDefaultState.averageHandlingTimeSeconds;
    }
};

export const assignKpiQueueThresholdFromLegacy = (
    legacyKpiThreshold?: IKpiQueueThreshold,
): ITelXLKpiQueueThreshold => {
    if (!legacyKpiThreshold) return TelXLKpiQueueThresholdDefaultState;

    return {
        slaThreshold: {
            low: legacyKpiThreshold.slaThreshold ?? 0,
            high: legacyKpiThreshold.slaThreshold ?? 0,
            enabled:
                legacyKpiThreshold.slaThreshold !== undefined &&
                legacyKpiThreshold.slaThreshold !== null,
        },
        maxConversationsWaiting: {
            low: legacyKpiThreshold.maxConversationsWaiting ?? 0,
            high: legacyKpiThreshold.maxConversationsWaiting ?? 0,
            enabled:
                legacyKpiThreshold.maxConversationsWaiting !== undefined &&
                legacyKpiThreshold.maxConversationsWaiting !== null,
        },
        averageWaitTimeSeconds: {
            low: legacyKpiThreshold.averageWaitTimeSeconds ?? 0,
            high: legacyKpiThreshold.averageWaitTimeSeconds ?? 0,
            enabled:
                legacyKpiThreshold.averageWaitTimeSeconds !== undefined &&
                legacyKpiThreshold.averageWaitTimeSeconds !== null,
        },
        maxLongestWaitTimeSeconds: {
            low: legacyKpiThreshold.maxLwtSeconds ?? 0,
            high: legacyKpiThreshold.maxLwtSeconds ?? 0,
            enabled:
                legacyKpiThreshold.maxLwtSeconds !== undefined &&
                legacyKpiThreshold.maxLwtSeconds !== null,
        },
        averageHandlingTimeSeconds: {
            low: 0,
            high: 0,
            target: 0,
            enabled: false,
        },
    };
};
